var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 10,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.664 2.602 4.808 6.973A4 4 0 0 1 2.132 8H0v2h20V8h-1.465a4 4 0 0 1-2.676-1.027l-4.857-4.37a1 1 0 0 0-1.338 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.995 1.859a2 2 0 0 1 2.676 0l4.857 4.37A3 3 0 0 0 18.535 7H15.89l-4.888-4.398a1 1 0 0 0-1.338 0L4.777 7H2.132a3 3 0 0 0 2.007-.77z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.333 3.345 5.477 7.716A5 5 0 0 1 2.132 9H0V8h2.132a4 4 0 0 0 2.676-1.027l4.856-4.37a1 1 0 0 1 1.338 0l4.857 4.37A4 4 0 0 0 18.535 8H20v1h-1.465a5 5 0 0 1-3.345-1.284z"
})));
export default SvgPointer;